<!--
 * @Description: 
 * @Author: 
 * @LastEditors: chengchongzhen
 * @Date: 2021-12-10 16:36:54
 * @LastEditTime: 2021-12-15 16:54:57
-->
<template>
  <div class="transfer-wrapper">
    <popper trigger="clickToOpen" :options="{
      placement: 'end',
      modifiers: { offset: { offset: '0,8px' } }
    }">
      <el-input

        placeholder="请选择"
        @focus="transferVisible = true"
        v-model="checkedValue"
        readonly
        slot="reference"
        
      >
      <!-- <i slot="suffix" @click="clear" class="el-input__icon el-icon-circle-close"></i> -->
      </el-input>
      <el-card class="box-card" :class="{ transferShow: transferVisible }" :body-style="{ padding: 0 }">
        <el-transfer
        :key="key"
          v-loading="loading"
          :left-default-checked="defaultCheckedList"
          filterable
          :filter-method="filterMethod"
          :filter-placeholder="placeholder"
          v-model="value"
          :data="data"
          :titles="['全选']"
          @left-check-change="transferChecked"
        >
          <template slot-scope="{ option }">
            <span class="item" style="width: 100%">{{ option.label }}</span>
          </template>
          <el-button
            class="transfer-footer"
            type="primary"
            slot="left-footer"
            size="mini"
            style="float: right; margin-top: 5px; margin-right: 5px"
            @click="confirmChecked"
            >确认</el-button
          >
        </el-transfer>
      </el-card>
    </popper>
  </div>
</template>

<script>
import { debounce, generateData } from './index.js'
import Popper from 'vue-popperjs'
import 'vue-popperjs/dist/vue-popper.css'
export default {
  components: {
    popper: Popper
  },
  props: {
    optionsList: {
      validator: (list = []) => {
        if (list.length === 0) {
          return true
        }
        return list.find(item => item.label)
      }
    },
    defaultChecked: {
      type: Array,
      default() {
        return []
      }
    },
    defaultText: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    placeholder:{
      type: String,
      default: '请输入学校名称'
    },
    filterMethod: {
      default() {
        return (query, item) => {
          return item.label.indexOf(query) > -1
        }
      }
    }
  },
  data() {
    return {
      data: generateData(this.optionsList),
      value: [],
      transferVisible: false,
      uncertainCheckedList: [],
      checkedList: [],
      checkedValue: '',
      scrollFunc: debounce(e => {
        const dom = e.target
        if (dom.scrollHeight <= dom.clientHeight + dom.scrollTop + 20) {
          this.$emit('scrollBottom')
        }
      }, 500),
      key:0,
      defaultCheckedList:[]
    }
  },
  watch: {
    optionsList(newValue) {
      this.data = generateData(newValue)
      this.key++
    }
  },

  created() {
    // document.querySelector('.el-checkbox-group').addEventListener('scroll', this.scrollFunc)
      if (this.defaultChecked.length>0) {
        // console.log(this.data,this.defaultChecked,'111111');
        this.defaultChecked.forEach((ele,index) => {
          let i = this.data.findIndex(el =>el.value == ele.value)
          this.defaultCheckedList.push(this.data[i].key)
          this.checkedValue = this.data[i].label
          this.uncertainCheckedList.push(this.data[i].key)
        })
      }
  },
  // destroyed() {
  //   document.querySelector('.el-checkbox-group').removeEventListener('scroll', this.scrollFunc)
  // },
  methods: {
    /**
     * @description: ui层次选中事件
     * @param {*} arrary 选中的list
     * @return {*}
     */
    transferChecked(arrary) {
      this.uncertainCheckedList = arrary
    },

    /**
     * @description: 确认选中事件
     * @param {*}
     * @return {*}
     */
    confirmChecked() {
      this.checkedValue = ''
      this.checkedList = []
      this.uncertainCheckedList.forEach(index => {
        this.checkedList.push(this.data[index])
        this.checkedValue += this.data[index].label + ','
      })
      this.checkedValue = this.checkedValue.replace(/\,$/g, '')
      this.transferVisible = false
      this.$emit('checked', this.checkedList)
    },
    // clear(){
    //   console.log(1); 
    // }
  }
}
</script>
<style lang="scss" scoped>
.transfer-wrapper {
  max-width: 260px;
  min-width: 215px;
  position: relative;
  display: inline-block;

  .el-card {
    min-width: 330px;
    max-width: 380px;
    opacity: 0;
    pointer-events: none;
    transition: none;
    z-index: 99999;
  }

  .transferShow {
    opacity: 1;
    pointer-events: auto;
  }
  .item {
    text-align: left;
    line-height: 1.2;
  }

  & ::v-deep {
    .el-transfer__buttons,
    .el-transfer-panel:nth-child(3) {
      display: none;
    }
    .el-transfer-panel {
      width: 100%;
    }
    .el-input {
      input:read-only {
        text-overflow: ellipsis;
      }
    }

    .el-transfer-panel__list {
      overflow-y: auto;
    }
    .el-transfer-panel__list::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    /* 滚动槽 */
    .el-transfer-panel__list::-webkit-scrollbar-track {
      box-shadow: inset006pxrgba(0, 0, 0, 0.3);
      border-radius: 10px;
    }
    /* 滚动条滑块 */
    .el-transfer-panel__list::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: #eee;
      box-shadow: inset006pxrgba(0, 0, 0, 0.5);
    }
    .el-transfer-panel__list::-webkit-scrollbar-thumb:hover {
      background: rgba(0, 0, 0, 0.1);
    }
    .el-transfer-panel .el-transfer-panel__footer{
      position: static
    }
  }
}
</style>
